export default "__VITE_ASSET__BqjHxkZ___"